import React, { useCallback, useContext } from 'react';
import { Logout } from '@mui/icons-material';
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppConst from './const';
import UserInfo from './UserInfo';
import MenuItemCollapse from './MenuItemItemCollpase';
import useStore from '../../states/store';

import menuTabItems from './menuTabItems';

export default function MenuList({ toggleDrawer }) {
  const auth = useStore((state) => state.auth);
  const { setToggleLogout } = useContext(AppConst.AppContext);

  const handleLogout = () => {
    setToggleLogout(true);
  };

  const handleToggleDrawer = useCallback(() => toggleDrawer(), []);
  /* test */
  // const renderDashboard = () => (
  //   <>
  //     <ListItem
  //       button
  //       to='/dashboard'
  //       key='dashboard'
  //       onClick={() =>
  //         handleChangePage({
  //           title: 'Dashboard',
  //           url: 'dashboard',
  //         })
  //       }

  //   </>
  // );
  // const menuArray = {
  //   KASM: menuItemsKASM,
  //   SAM: menuItemsKASM,
  //   KASOM: menuItemsKarsom,
  //   KASROM: menuItemsKarsom,
  //   KARSOM: menuItemsKarsom,
  //   admin: menuTabItems,
  //   sub_admin: menuItemsSubAdmin,
  //   SD: menuItemsSD,
  //   HTAM: menuItemsHTAM,
  //   RSM: menuItemsRSM,
  //   KASH: menuItemsKash,
  //   GPM: menuItemsPM,
  //   PM: menuItemsPM,
  //   'NSM-HOSPITAL': menuItemsNSMHospital,
  //   'NSM-SPARTAN': menuItemsNSMSpartan,
  //   DAM: menuItemsDAM,
  // };
  const renderMenuItems = () => {
    if (auth && auth.designation !== 'temp_admin') {
      return menuTabItems.map((row) => {
        if (row?.permissions.includes(auth.designation)) {
          if (row?.child) {
            return <MenuItemCollapse item={row} key={row.slug} onChangePage={handleToggleDrawer} />;
          }

          return (
            <ListItem
              button
              component={Link}
              to={row.url}
              key={row.slug}
              onClick={handleToggleDrawer}
            >
              <ListItemIcon>{row.icon}</ListItemIcon>
              <ListItemText primary={row.title} />
            </ListItem>
          );
        }
        return '';
      });
    }

    return '';
  };

  return (
    <Box sx={{ width: 250 }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-end',
          padding: 15,
        }}
      >
        <UserInfo />
      </div>
      <Divider />
      <List>
        {renderMenuItems()}
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <Logout />
            </ListItemIcon>
            <ListItemText primary='Logout' />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
}

MenuList.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
};
